/** 桌面主内容区：横向滚动（表内横滑）vs 整体缩放适应 */
export const LAYOUT_MODE_KEY = 'erp_desktop_main_layout_mode'
/**
 * v4：废止旧 fit（曾用 width:max-content 把 Grid/页撑出窗口，
 * 表现成「只有全屏才看不到横条」）。强制回 scroll，外壳钉窗口宽。
 */
export const LAYOUT_FIT_SAFE_FLAG = 'erp_desktop_layout_fit_safe_v4'

/** @returns {'scroll' | 'fit'} */
export function getStoredLayoutMode() {
  try {
    if (!localStorage.getItem(LAYOUT_FIT_SAFE_FLAG)) {
      // 清掉有害的旧 fit，回到窗口内自适 + 表内横滑
      localStorage.setItem(LAYOUT_MODE_KEY, 'scroll')
      localStorage.setItem(LAYOUT_FIT_SAFE_FLAG, '1')
    }
    const v = localStorage.getItem(LAYOUT_MODE_KEY)
    if (v === 'fit' || v === 'scroll') return v
  } catch {
    /* ignore */
  }
  return 'scroll'
}

/** @param {'scroll' | 'fit'} mode */
export function setStoredLayoutMode(mode) {
  try {
    localStorage.setItem(LAYOUT_MODE_KEY, mode)
  } catch {
    /* ignore */
  }
}
